import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Modal from './Modal'
import Radio, { RadioOption } from '@components/radio/Radio'
import Button from '@components/button/Button'

import useI18n from '@i18n/useI18n'

interface Props {
  data: RadioOption[]
  initValue?: RadioOption
  onChange: (opt?: RadioOption) => void
}

const SimpleAlertContent = ({ data, onChange, initValue }: Props) => {
  const i18n = useI18n()
  const [current, setCurrent] = React.useState(initValue)

  const onValidate = () => {
    onChange(current)
    SortByAlert.close()
  }

  return (
    <ModalContent>
      <Title>{i18n.t('components.sortByAlert.title')}</Title>
      <Radio iconOnTheRight horizontalPadding data={data} value={current} onItemSelected={setCurrent} />
      <ButtonContainer>
        <Button status="active" label={i18n.t('common.validate')} onClick={onValidate} color="light" />
      </ButtonContainer>
    </ModalContent>
  )
}

const SortByAlert = {
  open: (props: Props) => {
    Modal.open({
      Content: () => <SimpleAlertContent {...props} />,
      position: 'bottom',
    })
  },
  close: () => {
    Modal.close()
  },
}

export default SortByAlert

const ModalContent = styled(View)`
  width: 300px;
  border-radius: 4px;
  margin-bottom: 24px;
  background-color: ${(props) => props.theme.colors.background};
`
const Title = styled(Text)`
  ${(props) => props.theme.fonts.Footnote};
  color: ${(props) => props.theme.colors.secondaryText};
  padding: 16px 16px 8px;
`

const ButtonContainer = styled(View)`
  padding: 24px 16px 16px;
`
